const endpoints = {
  removeEps: (): string => `/strategy/unmark`,
  removeStrategy: (): string => `/strategy/unmark`,
  removeCustomer: (): string => `/strategy/unmark`,
  getCustomer: ({ customerId, distributionId }): string =>
    `distributions?customerId=${customerId}&distribuitonId=${distributionId}`,
  removeAll: ({ distributionId }): string =>
    `distributions?distribuitonId=${distributionId}`,
};

export default endpoints;
